<template>
  <div style="padding: 1rem 1rem;position: relative;transform: translate(0);">
    <div style="font-weight: 400;color: rgba(0,0,0,0.8);margin-bottom: 20px;" class="d-flex flex-y-center flex-between">
      <div class="d-flex flex-y-center pointer" style="padding: 0.3rem 0.3rem 0 0;" @click="goHome()">
        <img src="@/assets/icon-home.png" width="40" height="40" alt="">
        <span style="margin-left: 10px;color: rgba(0,0,0,0.8);font-weight: 600;font-size: 20px;">Contact Us</span>
      </div>
    </div>

    <div style="display: flex;align-items: center;gap: 6px;">
      <img src="@/assets/icon-email-contact.png" width="20" height="20" alt="" style="filter: grayscale(1);">
      <a style="font-weight: bold;" href="mailto:yilan2755@gmail.com">yilan2755@gmail.com</a>
    </div>
    <p style="margin-top: 1rem;color: rgba(0, 0, 0, 0.30);">If you have any questions, feel free to reach out to us ，Whether it's a partnership opportunity or a product issue, we’d love to hear from you and are always happy to help!</p>

  </div>
</template>

<script>
import request from '@/utils/request'
import { mapState, mapMutations } from 'vuex'
import * as SubmissionsApi from '@/api/submissions'

export default {
  name: 'Submissions',
  components: {

  },
  data() {
    return {
      
    }
  },
  computed: {
    ...mapState(['user', 'story', 'showDialogCdpFlag', 'enums',
      'showDialogDpFlag', 'showGenbyoutlineFlag', 'storyTiaojian', 'token'])
  },
  mounted() {
   
  },
  beforeDestroy() {
  },
  methods: {
    ...mapMutations(['setCurrentNotifyId', 'setActiveMenuItem', 'setStory']),
    goHome() {
      this.setActiveMenuItem('1')
      if (this.token === '') {
        this.$router.push('/')
      } else {
        this.$router.push('/home')
      }
    },
  }
}
</script>
